import Block from "../components/Block";
import Seam from "../components/Seam";
import Seo from "../components/Seo";

export default function Contact() {
  return (
    <>
      <Seo
        title="Contact"
        description="Reach Gapsmiths Consulting LLP in Mumbai. Email vivek@gapsmiths.com or call +91 93230 29857."
      />
      <section className="wrap page-head">
        <h1>Contact</h1>
        <p className="lede">
          The fastest way to reach us is email. We read everything and reply to most
          things within two working days.
        </p>
      </section>

      <Seam />

      <Block marker="Details">
        <dl className="rows">
          <div className="row">
            <dt>Email</dt>
            <dd><a href="mailto:vivek@gapsmiths.com">vivek@gapsmiths.com</a></dd>
          </div>
          <div className="row">
            <dt>Phone</dt>
            <dd><a href="tel:+919323029857">+91 93230 29857</a></dd>
          </div>
          <div className="row">
            <dt>Address</dt>
            <dd>
              <address>
                Gapsmiths Consulting LLP<br />
                Mumbai, Maharashtra, India
              </address>
            </dd>
          </div>
          <div className="row">
            <dt>GSTIN</dt>
            <dd>27AAPFG1889E1Z0</dd>
          </div>
        </dl>
      </Block>

      <Seam />

      <Block marker="Before you write">
        <h3>If it's about a project</h3>
        <p>
          Tell us what's not working rather than what you want us to build. We'll get
          to the useful part faster from there.
        </p>

        <h3>If it's about one of our products or systems</h3>
        <p>
          Mention which one. If it's a support or billing question, include the email
          address you used to sign up.
        </p>
      </Block>
    </>
  );
}
